<template>
  <div class="container-fluid notfound-wrapper">
    <div class="row min-vh-100">
      <div class="col-lg-6 d-none d-lg-flex notfound-left">
        <div class="notfound-left-content">
          <h1 class="headline">Ups, esta ruta no existe.</h1>
          <p class="subtitle">
            Te llevaremos automáticamente a la sección correcta de tu cuenta.
          </p>
          <p class="subtitle">
            TusCFDIs: más que un software, un aliado en tu crecimiento.
          </p>
        </div>
      </div>

      <div class="col-lg-6 col-12 d-flex align-items-center justify-content-center">
        <div class="notfound-card-modern">
          <div class="brand text-center mb-4">
            <img src="../../assets/images/logo/logo.png" alt="TusCFDIs" width="150" />
          </div>

          <div class="code">404</div>
          <h2 class="title text-center">Página no encontrada</h2>
          <p class="text-muted text-center mb-4">
            La ruta que intentaste abrir no está disponible.
          </p>

          <div class="hint text-center mb-4">
            Redirigiendo a <strong>{{ redirectTargetLabel }}</strong>...
          </div>

          <button class="btn btn-primary btn-lg w-100" @click="redirectNow">
            Ir ahora
          </button>

          <div class="auth-footer text-center mt-5">
            <div class="links">
              <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
              <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
            </div>
            <small class="d-block mt-3">© 2026 TusCFDIs México</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error-404',
  data() {
    return {
      redirectTimer: null
    }
  },
  computed: {
    isLoggedIn() {
      const token = localStorage.getItem('access_token')
      const user = localStorage.getItem('user')
      return !!token && token !== 'undefined' && !!user && user !== 'undefined'
    },
    redirectTarget() {
      return this.isLoggedIn ? { name: 'dashboard' } : { name: 'login' }
    },
    redirectTargetLabel() {
      return this.isLoggedIn ? 'Dashboard' : 'Inicio de sesión'
    }
  },
  mounted() {
    this.redirectTimer = setTimeout(() => {
      this.redirectNow()
    }, 10000)
  },
  beforeUnmount() {
    if (this.redirectTimer) clearTimeout(this.redirectTimer)
  },
  methods: {
    redirectNow() {
      this.$router.replace(this.redirectTarget)
    }
  }
}
</script>
